import { atom } from "recoil";

export const stateAgreement = atom({
  key: 'state/agreement',
  default: null,
});

export const appState = atom({
  key: 'state/app',
  default: {},
});